import { NavController, NavParams, App, ModalController, ViewController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';
import { AuthProvider } from '../../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../../providers/employeerh/employeerh';


@Component({
  selector: 'page-rh-custom-interview-signature',
  templateUrl: 'rh-custominterview-signature.html',
})
export class RhCustomInterviewSignature implements OnInit {

  interview:any = null;
  signature:string = null;

  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 300,
    'dotSize' : 1
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController
  ) {
    this.interview = this.navParams.get('interview');
  }

  drawComplete() {
    this.signature = this.signaturePad.toDataURL();
  }

  ngOnInit() {
       
  }

  clearCanvas(){
    this.signaturePad.clear();
    this.signature = null;
  }
  

  submit(){
    if(this.signature !== null){
      let payload = {
        process_id: this.interview.id,
        signature: this.signature
      }

      this.employeeRhProvider.saveUserCustomInterviewSignature(payload).subscribe((res) => {
        if(res.success){
          let toast = this.toastCtrl.create({ message: "Votre avez signer votre entretien", duration: 6000, position: 'bottom'});
          toast.present();
          this.dismiss();
        }
      })
    }

  }

   
// Modal ctrl
dismiss() {
    this.viewCtrl.dismiss();
}


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-custominterview/rh-custominterview-signature/rh-custominterview-signature.ts